import { render, staticRenderFns } from "./preview_1.vue?vue&type=template&id=2b9ff3d1&scoped=true"
import script from "./preview_1.vue?vue&type=script&lang=js"
export * from "./preview_1.vue?vue&type=script&lang=js"
import style0 from "./preview_1.vue?vue&type=style&index=0&id=2b9ff3d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ff3d1",
  null
  
)

export default component.exports